module.exports = __webpack_public_path__ + "img/06.6163c493.png";